export const FETCH_RMAS = 'FETCH_RMAS';
export const FETCH_RMAS_FULFILLED = 'FETCH_RMAS_FULFILLED';
export const FETCH_RMAS_REJECTED = 'FETCH_RMAS_REJECTED';
export const SEARCH_RMAS = 'SEARCH_RMAS';
export const SEARCH_RMAS_FULFILLED = 'SEARCH_RMAS_FULFILLED';
export const SEARCH_RMAS_REJECTED = 'SEARCH_RMAS_REJECTED';
export const CLEAR_ACCOUNT_RMAS = 'CLEAR_ACCOUNT_RMAS';
